/* eslint-disable */
import themeChangePalette from './Actions/ThemeChangePalette.action';
import themeChangePaletteTypeDark from './Actions/ThemeChangePaletteTypeDark.action';
import themeChangePaletteTypeLight from './Actions/ThemeChangePaletteTypeLight.action';
import themeTogglePaletteType from './Actions/ThemeTogglePaletteType.action';

const themeActionCreators = {
  themeChangePalette,
  themeChangePaletteTypeDark,
  themeChangePaletteTypeLight,
  themeTogglePaletteType,
};

export default themeActionCreators;
